<template>
    
    <div>
        <b-row>
            <b-col sm="12">
            <b-form-group>
                <b-form-input type="text" id="phonebookFilter" v-model="phonebookFilter" placeholder="Filtro" ></b-form-input>
            </b-form-group>
            </b-col>
        </b-row>

        <div class="Scroll">

            <b-list-group-item :href="item.email ? 'mailto:' + item.email : '#'" class="flex-column align-items-start" v-for="item in filteredPhonebookItems" :key="item.id">
                <div class="d-flex w-100">
                    <div class="pt-3 mr-3">
                        <div class="avatar">
                            
                            <img :src="item.avatar && item.avatar != '' ? (item.avatar.indexOf('/') > 0 ? '' : $store.state.currentUser.remotePath + $store.state.currentUser.avatarPath ) + item.avatar : 'img/noimage.png'" class="circle-img" alt="admin@bootstrapmaster.com">
                            <span class="avatar-status bg-success" v-if="item.online===true"></span>
                        </div>
                    </div>
                    
                       <div class="w-100">
                            <div class="text-muted"><small>{{ item.name }}</small></div>
                            <div class="font-weight-bold">{{ item.alias }}</div>
                            <div class="small text-muted text-truncate" v-show="item.email && item.email != ''" >{{ item.email }}</a></div>
                            <div class="small text-muted text-truncate">{{ item.jobName }}</div>
                        </div>
                    <div class="w-100">
                        <div class="d-flex w-100 font-weight-bold justify-content-end text-primary">{{ item.extNumber }}</div>
                        <div class="d-flex w-100 font-weight-bold justify-content-end text-primary">{{ item.phone1 }}</div>
                        <div class="d-flex w-100 font-weight-bold justify-content-end text-primary">{{ item.phone2 }}</div>
                    </div>
                    
                </div>
            </b-list-group-item>

        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'componentPhone',
    data: function() {
        return {
            phonebookFilter: '',
            phonebook: [],
        }
    },
    computed: {
        filteredPhonebookItems() {
            try {
                return this.phonebook.filter(item => {
                    return this.phonebookFilter=='' || item.name.toLowerCase().indexOf(this.phonebookFilter.toLowerCase()) > -1 || item.extNumber.toLowerCase().indexOf(this.phonebookFilter.toLowerCase()) > -1
                });
            }
            catch(ex) {
                return this.phonebook;
            }
        },
    },
    methods: {
        async refreshData() {
            var s = this;
            var currentUserURL = currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            
            if(currentUserURL.indexOf("undefined") >= 0)
                currentUserURL = ''
            /*            
            if(this.$store.state && this.$store.state.currentUser && this.$store.state.currentUser.id)
                currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            */
            await axios.get(
                this.$store.state.ws_url + "/portal/phonebook?companyId=" + s.$store.state.config.companyId + currentUserURL
            ).then(function(resp) {
                s.phonebook = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
            })
        },

    },
    mounted: function(){
        this.refreshData();
    }
}
</script>

<style scoped>
    .circle-img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    overflow: hidden;  
    }

   #wrapper {
        display:flex;    
        width:100%;
        align-content: streach;
        justify-content: space-between;
    }    

    #wrapper div {
        /* height:100px; */
    }

    .staticMain {
        flex: 0 0 800px;
    }
    .staticLeft {
        flex: 0 0 330px;
    }

    .staticDiv {
        flex: 0 0 10px;
    }

    .growMax {
        flex-grow: 1;
    }
    .Scroll {
        max-height: 400px;
        overflow-y: scroll;
    }
</style>
